import { Stack } from '@mui/material'
import { PayloadNotifications } from 'models/notifications'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'

export const DescriptionFields = ({ items }: PayloadNotifications) => {
	return (
		<Stack direction='column' gap={'8px'}>
			{items?.map((item, idx) => (
				<Stack
					key={`${item.label} : ${idx}`}
					direction='row'
					justifyContent='space-between'
				>
					<TypographyPrimary>{item.label}</TypographyPrimary>
					<TypographyPrimary16Bold>{item.value ?? '-'}</TypographyPrimary16Bold>
				</Stack>
			))}
		</Stack>
	)
}
